/* Salmatcha motion + cart intelligence v2 — FAIL-OPEN
   Content is never hidden unless the observer is confirmed live.
   Mobile gets instant content (no reveal hiding at all). */
(function () {
  'use strict';
  if (window.__salMotionInit) return;
  window.__salMotionInit = true;

  /* ---------- scroll reveal (desktop only, fail-open) ---------- */
  function initReveal() {
    try {
      if (window.matchMedia('(max-width: 767px)').matches) return; /* phones: instant, dense, trustworthy */
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var sel = ['.sal-benefit', '.sal-craft__item', '.sal-craft__content', '.sal-review',
        '.sal-category', '.sal-reviews__head', '.sal-categories__head', '.sal-benefits__head',
        '.sal-story__panel', '.sal-craft__panel'];
      var els = Array.prototype.slice.call(document.querySelectorAll(sel.join(',')));
      if (!els.length) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('sal-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      els.forEach(function (el) {
        var p = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.style.transitionDelay = Math.min(p * 60, 300) + 'ms';
        el.classList.add('sal-reveal');
        io.observe(el);
      });
      /* fail-open: whatever hasn't revealed after 1.2s becomes visible regardless */
      setTimeout(function () {
        els.forEach(function (el) { el.classList.add('sal-in'); });
      }, 1200);
    } catch (err) { /* never hide content on error */ }
  }

  /* ---------- m-select trigger: decode HTML entities ----------
     Fixes collection-switcher titles rendering as e.g. "Cups &amp; Tumblers"
     after selecting a tab: theme.js copies option.innerHTML into the
     trigger via textContent, double-encoding any "&" in the title.
     Fail-open: decode-only, never writes unless the decoded text differs. */
  function initSelectTitleFix() {
    try {
      var decode = function (el) {
        var t = el.textContent;
        if (t.indexOf('&') === -1) return;
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var d = doc.documentElement.textContent;
        if (d && d !== t) el.textContent = d;
      };
      var watch = function (el) {
        decode(el);
        new MutationObserver(function () { decode(el); }).observe(el, { childList: true, characterData: true, subtree: true });
      };
      document.querySelectorAll('.sf-select-custom--trigger-text').forEach(watch);
    } catch (err) { /* fail-open */ }
  }

  /* ---------- free-shipping progress bar ---------- */
  var THRESHOLD = 30000;
  function fmt(minor) { return 'AED ' + (minor / 100).toFixed(0); }
  function renderBar(totalMinor) {
    document.querySelectorAll('[data-sal-shipbar]').forEach(function (bar) {
      var fill = bar.querySelector('[data-sal-shipbar-fill]');
      var label = bar.querySelector('[data-sal-shipbar-label]');
      var pct = Math.min(totalMinor / THRESHOLD * 100, 100);
      if (fill) fill.style.width = pct + '%';
      if (label) {
        if (totalMinor <= 0) {
          label.textContent = 'Free GCC shipping on orders over ' + fmt(THRESHOLD);
        } else if (totalMinor >= THRESHOLD) {
          bar.classList.add('sal-shipbar--done');
          label.textContent = '🎉 You’ve unlocked free shipping!';
        } else {
          bar.classList.remove('sal-shipbar--done');
          label.textContent = 'You’re ' + fmt(THRESHOLD - totalMinor) + ' away from free shipping';
        }
      }
    });
  }
  function refreshCartState() {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderBar(cart.total_price);
        document.querySelectorAll('[data-sal-upsell]').forEach(function (u) {
          var vid = parseInt(u.getAttribute('data-sal-upsell-variant'), 10);
          var inCart = cart.items.some(function (i) { return i.variant_id === vid; });
          u.style.display = inCart ? 'none' : '';
        });
      })
      .catch(function () {});
  }

  /* ---------- upsell quick add ---------- */
  function initUpsell() {
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-sal-upsell-add]');
      if (!btn) return;
      ev.preventDefault();
      var vid = btn.getAttribute('data-variant-id');
      if (!vid || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      var orig = btn.textContent;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function (item) {
        btn.textContent = 'Added ✓';
        if (window.Shopify && typeof window.Shopify.onItemAdded === 'function') {
          window.Shopify.onItemAdded(item);
        }
        setTimeout(function () { btn.textContent = orig; btn.classList.remove('is-loading'); refreshCartState(); }, 1200);
      }).catch(function () {
        btn.textContent = orig;
        btn.classList.remove('is-loading');
      });
    });
  }

  function init() {
    initReveal();
    initSelectTitleFix();
    initUpsell();
    refreshCartState();
    if (window.MinimogEvents && window.MinimogEvents.subscribe) {
      window.MinimogEvents.subscribe('ON_CART_UPDATE', function () { refreshCartState(); });
      window.MinimogEvents.subscribe('ON_ITEM_ADDED', function () { refreshCartState(); });
    }
    document.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-open-cart-drawer], .sf-cart-icon, a[href="/cart"]')) {
        setTimeout(refreshCartState, 600);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
